export default __webpack_public_path__ + "static/media/logo-vertical-white.262cbf3b.svg";